import { render } from "./contract_dorder.vue?vue&type=template&id=00afa8df&scoped=true"
import script from "./contract_dorder.vue?vue&type=script&lang=js"
export * from "./contract_dorder.vue?vue&type=script&lang=js"

import "./contract_dorder.vue?vue&type=style&index=0&id=00afa8df&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00afa8df"]])

export default __exports__